export class DocPart {
  id: number;
  contents: string;
  description: string;
  name: string;
  is_global: boolean;
  matter_type_id: number = 0;
  expand_part: boolean;
  mandatory: boolean = true;
  is_to: boolean = false;
  is_cc: boolean = false;
  is_signature: boolean = false;
  is_salutation: boolean = false;
  is_re: boolean = false;
  type: string = '';
  return_data: any;
  contentText: string = '';
  expanded: boolean = false;
  saving: boolean = false;
  loading: boolean = false;
  searchTerm: string;
  deleting: boolean = false;
  idrt: any;
  doc_templates_count: number;
  matter_type_name: string;
}
